
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35694",
  depVersions: {
  "documents-public-ui": "static-1.35694",
  "atom": "static-1.5610",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.3025",
  "client-types": "static-1.523",
  "cssUtils": "static-1.1160",
  "customer-data-filters-ui": "static-1.41543",
  "customer-data-objects": "static-1.8251",
  "customer-data-property-utils": "static-1.8596",
  "documents-lib": "static-1.35699",
  "emoji-mart": "static-3.10",
  "flux-actions": "static-1.384",
  "FormsCommonComponents": "static-1.86940",
  "FormUrlGenerator": "static-2.5251",
  "foundations-theming-specialty": "static-1.2754",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5344",
  "highcharts": "static-8.118",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6127",
  "hs-test-utils": "static-1.8579",
  "hub-http": "static-1.6741",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12332",
  "HubStyleTokens": "static-2.12025",
  "I18n": "static-7.1724",
  "icons": "static-2.715",
  "jasmine-immutable": "static-1.3471",
  "jasmine-runner": "static-1.6995",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7684",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3413",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5913",
  "quartz": "static-1.7754",
  "react": "static-7.206",
  "react-dlb": "static-1.97",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17274",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5716",
  "react-virtualized": "static-2.115",
  "reference-resolvers-lite": "static-1.8650",
  "reporting-data": "static-1.69631",
  "reporting-reports": "static-1.69307",
  "reporting-snowflake": "static-1.58247",
  "reporting-testing-lib": "static-1.11564",
  "reporting-visualizations": "static-1.61705",
  "reselect": "static-3.20",
  "sales-content-partitioning": "static-1.9494",
  "sanitize": "static-1.5005",
  "sanitize-text": "static-1.8693",
  "SharedI18nStrings": "static-1.191",
  "SharedLegalStrings": "static-1.2262",
  "signup-constants": "static-1.20112",
  "signup-ui-url-generator": "static-2.8572",
  "StyleGuideUI": "static-3.521",
  "superstore": "static-1.5291",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5289",
  "ui-addon-form-validation": "static-1.11353",
  "ui-asset-management-lib": "static-1.11645",
  "ui-images": "static-2.1295",
  "UIComponents": "static-3.8971",
  "usage-tracker": "static-1.7878",
  "usage-tracker-container": "static-1.7868",
  "usage-tracker-core": "static-1.7728",
  "viral-links-lib": "static-1.7619",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10171",
  "foundations-components": "static-1.8848",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.459",
  "quartz-config": "static-1.1532",
  "quartz-core": "static-1.6973",
  "quick-fetch": "static-1.4266",
  "raven": "static-3.6435",
  "redux": "static-4.81",
  "redux-thunk": "static-2.88",
  "rpc-client-utils": "static-1.5203",
  "ui-addon-i18n": "static-1.11683",
  "ui-addon-upgrades": "static-9.18608",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4031",
  "quartz-webpack": "static-1.3978",
  "foundations-assets": "static-1.5425",
  "foundations-theming": "static-1.5038",
  "hub-http-janus": "static-1.920",
  "hub-http-shared-msw-handlers": "static-1.11002",
  "hubspotter-http": "static-1.5012",
  "trellis-components": "static-1.3274",
  "trellis-migration-context": "static-1.115",
  "sassPrefix": "static-1.423",
  "conversations-skeleton-state": "static-1.7650",
  "crm-message-bus": "static-1.44256",
  "customer-data-filters-ui-msw-helpers": "static-1.23978",
  "customer-data-objects-ui-components": "static-1.13573",
  "customer-data-reference-ui-components": "static-1.13713",
  "customer-data-ui-utilities": "static-1.10369",
  "events-data-lib": "static-1.790",
  "framework-builder-read-service-client": "static-1.4373",
  "hs-resources": "static-1.732",
  "immer": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3809",
  "inbound-db-properties-service-client": "static-1.4189",
  "multi-account-reference-resolvers": "static-1.1558",
  "onboarding-tours": "static-1.17480",
  "pulse": "static-1.1203",
  "reference-resolvers": "static-1.8722",
  "reporting-datasets-permissions-lib": "static-1.14869",
  "segments-client-types": "static-1.12380",
  "stylex": "static-1.49",
  "trellis-assets": "static-1.3255",
  "trellis-theming": "static-1.1580",
  "ui-addon-teams": "static-1.22076",
  "quartz-auth": "static-1.1429",
  "ui-business-units-lib": "static-1.9633",
  "usage-tracker-session-replay": "static-1.5564",
  "ai-components-ui-library": "static-1.10126",
  "ContentUtils": "static-1.69616",
  "customer-data-properties": "static-1.53248",
  "forms-ai-lib": "static-1.5067",
  "forms-utils-lib": "static-1.13424",
  "foundations-components-test-utils": "static-1.6331",
  "react-dnd-compat": "static-1.5147",
  "react-tinymce": "static-1.56371",
  "tinymce-config": "static-2.55497",
  "ui-gdpr-components": "static-1.10659",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.4023",
  "HeadJS": "static-2.837",
  "framer-motion": "static-1.87",
  "hs-test-utils-bend-plugin": "static-1.3690",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.441",
  "ui-fonts": "static-1.1287",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4842",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.239",
  "quartz-head": "static-1.1419",
  "web-vitals": "static-1.22",
  "batch-promise": "static-1.2087",
  "external-options-client-types": "static-1.4477",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1429",
  "frontend-preferences-client": "static-1.8460",
  "graphql": "static-1.96",
  "persist-promise": "static-1.4244",
  "reporting-client-types": "static-1.2899",
  "apollo-stack-hubspot": "static-3.102",
  "hubspot-apollo-client": "static-1.5413",
  "foundations-components-legacy": "static-1.1873",
  "quartz-routing": "static-1.1184",
  "hs-story-utils": "static-1.9961",
  "react-flip-move": "static-1.86",
  "nested-table": "static-1.759",
  "seat-types-lib": "static-1.1167",
  "timezone-utils": "static-2.5762",
  "react-create-root-preference": "static-1.121",
  "bend-plugin-foundations-components": "static-1.5117",
  "floating-ui": "static-1.71",
  "react-aria": "static-1.80",
  "tanstack-table": "static-1.69",
  "opentelemetry-fe-types": "static-1.336",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.17",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.711",
  "quartz-test": "static-1.1429",
  "quartz-tracking": "static-1.1133",
  "bend-plugin-chirp-manifest": "static-1.613",
  "chirp-fetch": "static-1.2436",
  "merchandise-lib": "static-1.289",
  "purchase-motions-components": "static-1.6720",
  "ts-schema": "static-1.4432",
  "bender-build-tools": "static-1.3648",
  "bend-plugin-foundations-theming": "static-1.3521",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.18",
  "tanstack-virtual": "static-1.46",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5125",
  "conditional-properties-service-client": "static-1.4149",
  "crm-pipelines-api-client-types": "static-1.4483",
  "event-emitter": "static-1.1497",
  "fdsr-migration-layer": "static-1.550",
  "multi-currency-client-types": "static-1.4048",
  "getting-started-shared-tasks": "static-1.19657",
  "growth-data-modal": "static-1.6215",
  "growth-onboarding-confetti": "static-1.3592",
  "growth-onboarding-next-action-utils": "static-1.3095",
  "navigation-components": "static-1.19320",
  "nest": "static-1.774",
  "onboarding-tours-client": "static-1.5695",
  "onboarding-tours-utils": "static-1.1547",
  "ui-shepherd-react": "static-3.10824",
  "ui-shepherd-tracker": "static-1.8205",
  "ui-universal-auth": "static-1.9857",
  "user-context": "static-1.5595",
  "bend-plugin-pulse": "static-1.706",
  "fast-json-patch": "static-1.77",
  "crm-index-associations-lib": "static-1.6987",
  "stylex-utils": "static-1.191",
  "hubspotter-http-shared-msw-handlers": "static-1.11000",
  "magpie-lib": "static-1.5960",
  "navigation-messaging": "static-1.8647",
  "amplitude-session-replay-browser": "static-1.80",
  "chatspot-core": "static-1.24268",
  "copilot-toolkit": "static-1.12262",
  "cms-field-types": "static-1.5350",
  "content-icons-ui": "static-1.2521",
  "integrations-lib": "static-1.17559",
  "calling-global-api": "static-1.66505",
  "calling-internal-common": "static-1.31859",
  "calling-lifecycle-internal": "static-1.67887",
  "calling-lifecycle-messages": "static-1.60179",
  "commerce-products-lib": "static-1.11090",
  "crm-index-visualization-core": "static-1.4849",
  "crm-links": "static-1.6864",
  "customer-data-properties-shared-msw-handlers": "static-1.10329",
  "data-agent-utils": "static-1.1060",
  "data-token-picker": "static-1.17222",
  "file-manager-components": "static-1.24932",
  "formula-editor": "static-1.15082",
  "google-libphonenumber": "static-1.53",
  "inbounddb-objects-service-types": "static-1.4553",
  "meetings-icalendar-utils-lib": "static-1.1172",
  "object-builder-ui-client": "static-1.50212",
  "pipeline-validation-client-types": "static-1.4321",
  "property-value-citations": "static-1.3862",
  "react-colorpicker": "static-2.10746",
  "rich-text-lib": "static-1.20643",
  "smart-data-capture-core": "static-1.608",
  "tiered-pricing": "static-1.2386",
  "tinymce-plugins": "static-1.58611",
  "tinymce-themes": "static-1.57467",
  "topics-actions-lib": "static-1.730",
  "trellis-ext-i18n": "static-1.1478",
  "trial-components-library": "static-1.14480",
  "ui-addon-emoji-picker": "static-1.10401",
  "ui-addon-iframeable": "static-1.9617",
  "zustand": "static-1.93",
  "final-form": "static-1.86",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.85",
  "hub-http-contrib": "static-1.3566",
  "interframe": "static-3.5282",
  "tinymce-data": "static-1.41582",
  "ui-addon-sales-email": "static-1.5744",
  "hubspot-apollo-cache": "static-1.872",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.691",
  "opentelemetry-web": "static-1.26",
  "onboarding-scopes": "static-1.6989",
  "purchase-motions-api": "static-1.6723",
  "onboarding-data-sync-lib": "static-1.2921",
  "growth-onboarding-next-action-components": "static-1.3123",
  "user-context-client": "static-1.5043",
  "idb-keyval": "static-1.58",
  "magpie-types": "static-1.5420",
  "reactive-lib": "static-1.1258",
  "simple-logging-lib": "static-1.3584",
  "custom-vendor-connection-lib": "static-1.421",
  "unified-auth-core-lib": "static-1.1653",
  "getting-started-shared-tasks-store": "static-1.18775",
  "nav-meta": "static-1.30957",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2384",
  "integrations-error-boundary-lib": "static-1.14974",
  "integrations-tracking-lib": "static-1.6165",
  "native-integrations-shared-strings": "static-1.8295",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10909",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31866",
  "shared-worker-versioning": "static-1.11577",
  "calling-usage-tracker": "static-1.7078",
  "customer-data-tracking": "static-1.7408",
  "voice-sms-access-library": "static-1.2607",
  "commerce-permissions": "static-1.1320",
  "growth-payments-core": "static-1.26624",
  "products-iframe-lib": "static-1.9055",
  "products-ui-components-shared-msw-handlers": "static-1.11384",
  "sales-views-client-types": "static-1.4795",
  "location-customization-utils-lib": "static-1.10553",
  "data-agent-kit": "static-1.1047",
  "enrichment-settings-lib": "static-1.405",
  "fsm": "static-1.4297",
  "policy-lib": "static-1.7341",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4681",
  "poll-commands": "static-1.4013",
  "video-components-external": "static-1.12547",
  "video-data-lib": "static-1.36205",
  "bark-lib": "static-1.17070",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6433",
  "react-codemirror": "static-1.11179",
  "upgrade-components-lib": "static-1.794",
  "FileManagerLib": "static-1.40572",
  "content-assistance-lib": "static-1.8503",
  "FileManagerCore": "static-1.40431",
  "layout-dnd-components": "static-1.13317",
  "layout-dnd-utils": "static-1.12292",
  "ui-brand-identity-lib": "static-1.17095",
  "NamespacedHubStyle": "static-2.9406",
  "embedded-academy-lib": "static-1.16194",
  "hubs-service-types": "static-1.1803",
  "nudge-client-utils": "static-1.3508",
  "salesImages": "static-1.795",
  "InboxConnectUtils": "static-4.15953",
  "meetings-connect-utils-lib": "static-1.8156",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1362",
  "breeze-engine-core": "static-1.1662",
  "highlight.js": "static-1.93",
  "universal-page-editor-lib": "static-1.3557",
  "calling-orchestration-schema": "static-1.37384",
  "ui-addon-opt": "static-4.8970",
  "crm-record-cards-service-types": "static-1.3894",
  "trellis-story-utils": "static-1.5033",
  "storybook-react": "static-1.47",
  "content-media-composition-data-lib": "static-1.13688",
  "content-media-compositions": "static-2.17695",
  "media-bridge-lib": "static-1.19728",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16768",
  "browser-eslint": "static-2.57",
  "audio-components": "static-1.6650",
  "FileManagerImages": "static-1.38083",
  "video-components": "static-1.14549",
  "ui-addon-video-player": "static-1.9159",
  "ui-coaching-tips": "static-1.29640",
  "breeze-artifacts-sdk": "static-1.1200",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30147",
  "html-to-image": "static-1.68",
  "urlinator": "static-1.5053",
  "video-embed": "static-1.37039",
  "ContentData": "static-1.69691",
  "layout-data-lib": "static-1.10617",
  "academy-common-lib": "static-1.15655",
  "nudge-custom-function-registry": "static-1.3265",
  "nudge-renderer-utils": "static-1.3584",
  "whisper-core-api": "static-1.7735",
  "crm-record-cards-client": "static-1.225",
  "framework-data-schema-resolvers": "static-1.7431",
  "social-insights-client-types": "static-1.23041",
  "growth-onboarding-feedback-components": "static-1.7121",
  "outpost": "static-1.4662",
  "advanced-menus-core": "static-1.15908",
  "advanced-menus-lib": "static-1.12638",
  "ExportDialog": "static-6.10911",
  "ui-memberships-settings-lib": "static-1.35325",
  "academy-service-client": "static-1.4229",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4932",
  "trellis-ecosystem": "static-1.7937",
  "ui-addon-react-router-dom": "static-1.10064",
  "framework-data-schema-quick-fetch": "static-1.7336",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15907",
  "simple-menus-lib": "static-1.17424",
  "settings-ui-lib": "static-1.13069",
  "marketplace-ui-apps-core": "static-1.19685",
  "marketplace-ui-common": "static-1.21153",
  "developer-experience-shared-components": "static-1.11081",
  "immutable-less": "static-1.5185",
  "marketplace-ui-client-types": "static-1.18560",
  "ui-addon-integrations-directory-panel": "static-2.8486",
  "ui-extensibility-client-types": "static-1.4455",
  "ai-settings-ui-library": "static-1.8685",
  "ui-product-approvals-common": "static-1.1806",
  "apps-service-types": "static-1.4145",
  "oauth-service-types": "static-1.4673",
  "simple-data-table": "static-1.3936"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35694",
  "atom": "/atom/static-1.5610",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.3025",
  "client-types": "/client-types/static-1.523",
  "cssUtils": "/cssUtils/static-1.1160",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41543",
  "customer-data-objects": "/customer-data-objects/static-1.8251",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8596",
  "documents-lib": "/documents-lib/static-1.35699",
  "emoji-mart": "/emoji-mart/static-3.10",
  "flux-actions": "/flux-actions/static-1.384",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86940",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5251",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2754",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5344",
  "highcharts": "/highcharts/static-8.118",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6127",
  "hs-test-utils": "/hs-test-utils/static-1.8579",
  "hub-http": "/hub-http/static-1.6741",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12332",
  "HubStyleTokens": "/HubStyleTokens/static-2.12025",
  "I18n": "/I18n/static-7.1724",
  "icons": "/icons/static-2.715",
  "jasmine-immutable": "/jasmine-immutable/static-1.3471",
  "jasmine-runner": "/jasmine-runner/static-1.6995",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7684",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3413",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5913",
  "quartz": "/quartz/static-1.7754",
  "react": "/react/static-7.206",
  "react-dlb": "/react-dlb/static-1.97",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17274",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5716",
  "react-virtualized": "/react-virtualized/static-2.115",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8650",
  "reporting-data": "/reporting-data/static-1.69631",
  "reporting-reports": "/reporting-reports/static-1.69307",
  "reporting-snowflake": "/reporting-snowflake/static-1.58247",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11564",
  "reporting-visualizations": "/reporting-visualizations/static-1.61705",
  "reselect": "/reselect/static-3.20",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9494",
  "sanitize": "/sanitize/static-1.5005",
  "sanitize-text": "/sanitize-text/static-1.8693",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2262",
  "signup-constants": "/signup-constants/static-1.20112",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8572",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "superstore": "/superstore/static-1.5291",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5289",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11645",
  "ui-images": "/ui-images/static-2.1295",
  "UIComponents": "/UIComponents/static-3.8971",
  "usage-tracker": "/usage-tracker/static-1.7878",
  "usage-tracker-container": "/usage-tracker-container/static-1.7868",
  "usage-tracker-core": "/usage-tracker-core/static-1.7728",
  "viral-links-lib": "/viral-links-lib/static-1.7619",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10171",
  "foundations-components": "/foundations-components/static-1.8848",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "quartz-config": "/quartz-config/static-1.1532",
  "quartz-core": "/quartz-core/static-1.6973",
  "quick-fetch": "/quick-fetch/static-1.4266",
  "raven": "/raven/static-3.6435",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.88",
  "rpc-client-utils": "/rpc-client-utils/static-1.5203",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11683",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18608",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4031",
  "quartz-webpack": "/quartz-webpack/static-1.3978",
  "foundations-assets": "/foundations-assets/static-1.5425",
  "foundations-theming": "/foundations-theming/static-1.5038",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11002",
  "hubspotter-http": "/hubspotter-http/static-1.5012",
  "trellis-components": "/trellis-components/static-1.3274",
  "trellis-migration-context": "/trellis-migration-context/static-1.115",
  "sassPrefix": "/sassPrefix/static-1.423",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7650",
  "crm-message-bus": "/crm-message-bus/static-1.44256",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23978",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13573",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13713",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10369",
  "events-data-lib": "/events-data-lib/static-1.790",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4373",
  "hs-resources": "/hs-resources/static-1.732",
  "immer": "/immer/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3809",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4189",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1558",
  "onboarding-tours": "/onboarding-tours/static-1.17480",
  "pulse": "/pulse/static-1.1203",
  "reference-resolvers": "/reference-resolvers/static-1.8722",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14869",
  "segments-client-types": "/segments-client-types/static-1.12380",
  "stylex": "/stylex/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.3255",
  "trellis-theming": "/trellis-theming/static-1.1580",
  "ui-addon-teams": "/ui-addon-teams/static-1.22076",
  "quartz-auth": "/quartz-auth/static-1.1429",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9633",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5564",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10126",
  "ContentUtils": "/ContentUtils/static-1.69616",
  "customer-data-properties": "/customer-data-properties/static-1.53248",
  "forms-ai-lib": "/forms-ai-lib/static-1.5067",
  "forms-utils-lib": "/forms-utils-lib/static-1.13424",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6331",
  "react-dnd-compat": "/react-dnd-compat/static-1.5147",
  "react-tinymce": "/react-tinymce/static-1.56371",
  "tinymce-config": "/tinymce-config/static-2.55497",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.4023",
  "HeadJS": "/HeadJS/static-2.837",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3690",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.441",
  "ui-fonts": "/ui-fonts/static-1.1287",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4842",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.239",
  "quartz-head": "/quartz-head/static-1.1419",
  "web-vitals": "/web-vitals/static-1.22",
  "batch-promise": "/batch-promise/static-1.2087",
  "external-options-client-types": "/external-options-client-types/static-1.4477",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1429",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8460",
  "graphql": "/graphql/static-1.96",
  "persist-promise": "/persist-promise/static-1.4244",
  "reporting-client-types": "/reporting-client-types/static-1.2899",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.102",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5413",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1873",
  "quartz-routing": "/quartz-routing/static-1.1184",
  "hs-story-utils": "/hs-story-utils/static-1.9961",
  "react-flip-move": "/react-flip-move/static-1.86",
  "nested-table": "/nested-table/static-1.759",
  "seat-types-lib": "/seat-types-lib/static-1.1167",
  "timezone-utils": "/timezone-utils/static-2.5762",
  "react-create-root-preference": "/react-create-root-preference/static-1.121",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5117",
  "floating-ui": "/floating-ui/static-1.71",
  "react-aria": "/react-aria/static-1.80",
  "tanstack-table": "/tanstack-table/static-1.69",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.336",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.17",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.711",
  "quartz-test": "/quartz-test/static-1.1429",
  "quartz-tracking": "/quartz-tracking/static-1.1133",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.613",
  "chirp-fetch": "/chirp-fetch/static-1.2436",
  "merchandise-lib": "/merchandise-lib/static-1.289",
  "purchase-motions-components": "/purchase-motions-components/static-1.6720",
  "ts-schema": "/ts-schema/static-1.4432",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3521",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.18",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5125",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4149",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4483",
  "event-emitter": "/event-emitter/static-1.1497",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.550",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4048",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19657",
  "growth-data-modal": "/growth-data-modal/static-1.6215",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3592",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3095",
  "navigation-components": "/navigation-components/static-1.19320",
  "nest": "/nest/static-1.774",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5695",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1547",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10824",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8205",
  "ui-universal-auth": "/ui-universal-auth/static-1.9857",
  "user-context": "/user-context/static-1.5595",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.706",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6987",
  "stylex-utils": "/stylex-utils/static-1.191",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11000",
  "magpie-lib": "/magpie-lib/static-1.5960",
  "navigation-messaging": "/navigation-messaging/static-1.8647",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "chatspot-core": "/chatspot-core/static-1.24268",
  "copilot-toolkit": "/copilot-toolkit/static-1.12262",
  "cms-field-types": "/cms-field-types/static-1.5350",
  "content-icons-ui": "/content-icons-ui/static-1.2521",
  "integrations-lib": "/integrations-lib/static-1.17559",
  "calling-global-api": "/calling-global-api/static-1.66505",
  "calling-internal-common": "/calling-internal-common/static-1.31859",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67887",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60179",
  "commerce-products-lib": "/commerce-products-lib/static-1.11090",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4849",
  "crm-links": "/crm-links/static-1.6864",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10329",
  "data-agent-utils": "/data-agent-utils/static-1.1060",
  "data-token-picker": "/data-token-picker/static-1.17222",
  "file-manager-components": "/file-manager-components/static-1.24932",
  "formula-editor": "/formula-editor/static-1.15082",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4553",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1172",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50212",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4321",
  "property-value-citations": "/property-value-citations/static-1.3862",
  "react-colorpicker": "/react-colorpicker/static-2.10746",
  "rich-text-lib": "/rich-text-lib/static-1.20643",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.608",
  "tiered-pricing": "/tiered-pricing/static-1.2386",
  "tinymce-plugins": "/tinymce-plugins/static-1.58611",
  "tinymce-themes": "/tinymce-themes/static-1.57467",
  "topics-actions-lib": "/topics-actions-lib/static-1.730",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1478",
  "trial-components-library": "/trial-components-library/static-1.14480",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10401",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9617",
  "zustand": "/zustand/static-1.93",
  "final-form": "/final-form/static-1.86",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "hub-http-contrib": "/hub-http-contrib/static-1.3566",
  "interframe": "/interframe/static-3.5282",
  "tinymce-data": "/tinymce-data/static-1.41582",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5744",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.872",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.691",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "onboarding-scopes": "/onboarding-scopes/static-1.6989",
  "purchase-motions-api": "/purchase-motions-api/static-1.6723",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2921",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3123",
  "user-context-client": "/user-context-client/static-1.5043",
  "idb-keyval": "/idb-keyval/static-1.58",
  "magpie-types": "/magpie-types/static-1.5420",
  "reactive-lib": "/reactive-lib/static-1.1258",
  "simple-logging-lib": "/simple-logging-lib/static-1.3584",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.421",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1653",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18775",
  "nav-meta": "/nav-meta/static-1.30957",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14974",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6165",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8295",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10909",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31866",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11577",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7078",
  "customer-data-tracking": "/customer-data-tracking/static-1.7408",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2607",
  "commerce-permissions": "/commerce-permissions/static-1.1320",
  "growth-payments-core": "/growth-payments-core/static-1.26624",
  "products-iframe-lib": "/products-iframe-lib/static-1.9055",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11384",
  "sales-views-client-types": "/sales-views-client-types/static-1.4795",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10553",
  "data-agent-kit": "/data-agent-kit/static-1.1047",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.405",
  "fsm": "/fsm/static-1.4297",
  "policy-lib": "/policy-lib/static-1.7341",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4681",
  "poll-commands": "/poll-commands/static-1.4013",
  "video-components-external": "/video-components-external/static-1.12547",
  "video-data-lib": "/video-data-lib/static-1.36205",
  "bark-lib": "/bark-lib/static-1.17070",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6433",
  "react-codemirror": "/react-codemirror/static-1.11179",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.794",
  "FileManagerLib": "/FileManagerLib/static-1.40572",
  "content-assistance-lib": "/content-assistance-lib/static-1.8503",
  "FileManagerCore": "/FileManagerCore/static-1.40431",
  "layout-dnd-components": "/layout-dnd-components/static-1.13317",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12292",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17095",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9406",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16194",
  "hubs-service-types": "/hubs-service-types/static-1.1803",
  "nudge-client-utils": "/nudge-client-utils/static-1.3508",
  "salesImages": "/salesImages/static-1.795",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15953",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8156",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1362",
  "breeze-engine-core": "/breeze-engine-core/static-1.1662",
  "highlight.js": "/highlight.js/static-1.93",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3557",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37384",
  "ui-addon-opt": "/ui-addon-opt/static-4.8970",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3894",
  "trellis-story-utils": "/trellis-story-utils/static-1.5033",
  "storybook-react": "/storybook-react/static-1.47",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13688",
  "content-media-compositions": "/content-media-compositions/static-2.17695",
  "media-bridge-lib": "/media-bridge-lib/static-1.19728",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16768",
  "browser-eslint": "/browser-eslint/static-2.57",
  "audio-components": "/audio-components/static-1.6650",
  "FileManagerImages": "/FileManagerImages/static-1.38083",
  "video-components": "/video-components/static-1.14549",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9159",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29640",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1200",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30147",
  "html-to-image": "/html-to-image/static-1.68",
  "urlinator": "/urlinator/static-1.5053",
  "video-embed": "/video-embed/static-1.37039",
  "ContentData": "/ContentData/static-1.69691",
  "layout-data-lib": "/layout-data-lib/static-1.10617",
  "academy-common-lib": "/academy-common-lib/static-1.15655",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3265",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3584",
  "whisper-core-api": "/whisper-core-api/static-1.7735",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.225",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7431",
  "social-insights-client-types": "/social-insights-client-types/static-1.23041",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7121",
  "outpost": "/outpost/static-1.4662",
  "advanced-menus-core": "/advanced-menus-core/static-1.15908",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12638",
  "ExportDialog": "/ExportDialog/static-6.10911",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35325",
  "academy-service-client": "/academy-service-client/static-1.4229",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4932",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7937",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10064",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7336",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15907",
  "simple-menus-lib": "/simple-menus-lib/static-1.17424",
  "settings-ui-lib": "/settings-ui-lib/static-1.13069",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19685",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21153",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11081",
  "immutable-less": "/immutable-less/static-1.5185",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18560",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8486",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4455",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8685",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1806",
  "apps-service-types": "/apps-service-types/static-1.4145",
  "oauth-service-types": "/oauth-service-types/static-1.4673",
  "simple-data-table": "/simple-data-table/static-1.3936"
}
};
